import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetXmlTableTableData: '[GetXmlTableTableData] Action',
  SetXmlTableData: '[SetXmlTableData] Action',
  GetXmlTableTranslateData: '[GetXmlTableTranslateData] Action',
}

const initialXmlTableState: IXmlTableState = {
  xmlTableColumnList: [],
  xmlTableColumnValues: [],
  xmlTableDefinitions: [],
  xmlTableColumnNames: [],
  xmlTableDataTypes: [],
  xmlTableDe: [],
  xmlTableEn: [],

  xmlTablesOptions: []
}

export interface IXmlTableState {
  xmlTableColumnValues: [],
  xmlTableColumnList: [],
  xmlTableDefinitions: []
  xmlTableColumnNames: [],
  xmlTableDataTypes: [],
  xmlTableDe: [],
  xmlTableEn: [],

  xmlTablesOptions: []
}

export const reducer = persistReducer(
  { storage, key: 'portal-XmlTable', whitelist:  [ ] },
  (state: IXmlTableState = initialXmlTableState, action: any) => {
    switch (action.type) {
      case actionTypes.GetXmlTableTableData: {
        const xmlTableColumnValues = JSON.parse(action.payload.data.xmlTables);
        let headers = JSON.parse(action.payload.data.headers);
        let xmlTableDefinitions = JSON.parse(action.payload.data.definitions);
        let xmlTableColumnNames = action.payload.data.columnNames;
        let xmlTableDataTypes = action.payload.data.dataTypes;
        let xmlTableColumnList: any = [];
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          xmlTableColumnList.push(newElement[0]);
        });
        return { ...state, xmlTableColumnList, xmlTableColumnValues, xmlTableDefinitions, xmlTableDataTypes , xmlTableColumnNames};
      }
    
      case actionTypes.SetXmlTableData: {
        const xmlTableColumnValues = action.payload.data;
        return { ...state, xmlTableColumnValues };
      }

      case actionTypes.GetXmlTableTranslateData: {
        const xmlTableDe = JSON.parse(action.payload.data.de);
        const xmlTableEn = JSON.parse(action.payload.data.en);
        return { ...state, xmlTableDe, xmlTableEn };
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  getXmlTableTableData: (data: any) => ({ type: actionTypes.GetXmlTableTableData, payload: { data } }),
  getTranslateData: (data: any) => ({ type: actionTypes.GetXmlTableTranslateData, payload: { data } }),
  setXmlTableData: (data: any) => ({ type: actionTypes.SetXmlTableData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
